//
// PropertyOwner.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "./PropertyHandle";

var PropertyOwner = createModule("commons::PropertyOwner", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getPropertyHandle: [1,7],
    },
    ,
    ,
]);
export default PropertyOwner;
